import { Head } from '@inertiajs/react'
import { DealsTable } from "@/components/deals-table"

export default function Index() {
  return (
    <>
      <Head title="Deals" />
      <DealsTable title="Active Deal" subtitle="Setup in accounting, and ready for business" hiddenColumns={["requests"]} />
    </>
  )
}
